export default "__VITE_ASSET__i4K2fjsB__"